<template>
  <div class="content-item">
    <a-row class="mt-3">
      <a-col :span="24" class="left-col">
        <h3>Video Release</h3>
        <p>Please read the following release and sign below.</p>
        <p>
          I hereby grant True Life Inc (the “Organization”) the irrevocable right and permission to use photographs and/or video recordings of me on websites and in publications, or for any other
          similar purpose without compensation to me.
        </p>
        <p>
          I understand and agree that such photographs and/or video recordings of me may be placed on the Internet. I also understand and agree that I may be identified by them. I waive the right to
          approve the final product. I agree that all photographs, video and audio recordings, and any reproductions thereof, and all digital files are and shall remain the property of the
          Organization.
        </p>
        <p>
          I hereby release, acquit and forever discharge True Life Inc of any and all claims, demands, rights, promises, damages and liabilities arising out of or in connection with the use or
          distribution of said photographs and/or video recordings, including but not limited to any claims for invasion of privacy, appropriation of likeness or defamation.
        </p>
        <p>
          I hereby warrant that I am eighteen (18) years old or more and competent to contract in my own name or, if I am less than eighteen years old, that my parent or guardian has signed my release
          form below. This release is binding on me and my heirs, assigns and personal representatives.
        </p>
      </a-col>
    </a-row>
    <a-row class="mt-3 mb-4">
      <a-col :xs="24" :lg="18">
        <a-row>
          <a-col :span="24" class="left-col">
            <h3>Please click and draw your signature in the box blow.</h3>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <vue-signature-pad id="signature" width="100%" height="230px" ref="signaturePad" :options="{ penColor: '#000' }" />
          </a-col>
        </a-row>
        <a-row class="mt-3">
          <a-col :span="12">
            <a-button type="danger" class="action-button" @click.prevent="onClear">
              <span>{{ $t('button.clear') }}</span>
            </a-button>
          </a-col>
          <a-col :span="12">
            <a-button type="primary" class="action-button" @click.prevent="onSubmit">
              <span>{{ $t('button.submit') }}</span>
            </a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  methods: {
    onClear() {
      this.$refs.signaturePad.clearSignature();

      const parent = document.getElementById('signature');
      const canvas = document.getElementsByTagName('canvas')[0];
      canvas.width = parent.clientWidth;
      canvas.height = parent.clientHeight;
      console.log('3433333333', canvas.width, canvas.height);
    },
    onSubmit() {
      const { data, isEmpty } = this.$refs.signaturePad.saveSignature();
      if (isEmpty) {
        this.$notification['warning']({
          message: 'Please draw your signature!',
        });

        return;
      }
      this.$emit('onSubmit', data);
    },
  },
};
</script>

<style lang="scss" scoped>
.content-item {
  padding: 8px;

  .left-col {
    text-align: left;
  }

  h3 {
    font-size: 18px;
    font-weight: 500;
    text-decoration: underline;
  }

  p {
    font-size: 16px;
  }

  #signature {
    border: 1px solid #f8f8f8;
    border-radius: 4px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
  }

  .action-button {
    width: 120px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
  }
}
</style>
